import React from "react";
import Input from "../FormComponents/Input";

const EditSearchBox = ({ setEditElementData, editElementData }) => {
  const handleChange = (e) => {
    setEditElementData({ ...editElementData, [e.target.name]: e.target.value });
  };
  return (
    <div className="builder_form">
      <Input label="Enter Placeholder" value={editElementData.placeholder} name="placeholder" onChange={handleChange} />
    </div>
  );
};

export default EditSearchBox;
